import { Grid, Menu, MenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() =>
  createStyles({
    accUserLogo: {
      width: "120px",
      height: "120px",
      backgroundColor: "#f6f9fc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
    },
    accUserLogoImg: {
      width: "90.5px",
      height: "87.94px",
    },
    noMemberHeading: {
      fontSize: "22px",
      color: colors.gray500,
      fontWeight: 400,
      marginTop: "2rem",
    },
    noMemberSubheading: {
      fontSize: "16px",
      marginBottom: "24px",
      fontWeight: 400,
      color: colors.gray500,
    },
  })
);

export const AddMemberButtonContainer = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
}));

export const MemberSearchFieldContainer = styled(Grid)(() => ({
  paddingRight: "12px !important",
}));

export const MemberHeaderContainer = styled(Grid)(() => ({
  marginBottom: "24px",
}));

export const MemberCardContainer = styled(Grid)(() => ({
  rowGap: "24px",
  columnGap: "24px",
}));

export const MemberCardWrapper = styled(Grid)(() => ({
  maxHeight: "120px",
  borderRadius: "12px",
  border: `1px solid ${colors.gray200}`,
  padding: "12px 24px",
  display: "flex",
  flexDirection: "row",
  width: "calc(50% - 12px)",
}));

export const MemberCardContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  position: "relative",
  width: "100%",
}));

export const MemberCardAvatar = styled("div")(() => ({
  borderRadius: "50%",
  width: "80px",
  height: "80px",
  backgroundColor: colors.brandBlue50,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "24px",
  "& span": {
    color: colors.brandBlue500,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "32px",
    fontWeight: 500,
    lineHeight: "48px",
    letterSpacing: "0.2px",
  },
}));

export const MemberCardInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: 1,
  "& span:nth-child(1)": {
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 700,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  },
  "& span:nth-child(2)": {
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "24px",
    fontWeight: 500,
    lineHeight: "32px",
  },
  "& span:nth-child(3)": {
    color: colors.gray600,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "16",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
  },
}));

export const MemberCardOptions = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "center",
  cursor: "pointer",
}));

export const MemberListContainer = styled("div")(() => ({
  width: "100%",
  fontFamily: "Manrope !important",
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const MemberListAvatarContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));

export const MemberListAvatarBadge = styled("div")(() => ({
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  backgroundColor: colors.brandBlue50,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: "12px",
  "& span": {
    color: colors.brandBlue500,
    textAlign: "center",
    fontFamily: "Manrope",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "0.15px",
  },
}));

export const MoreOptionsMenu = styled(Menu)(() => ({
  "& .MuiPaper-root": {
    width: "200px",
    padding: "12px 0",
    borderRadius: "12px",
    background: colors.white,
    boxShadow: "0px 2px 6px 2px rgba(71, 84, 103, 0.15), 0px 1px 2px 0px rgba(71, 84, 103, 0.30)",
  },
  "& .MuiList-padding": {
    padding: 0,
  },
}));

export const OptionMenu = styled(MenuItem)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  "&.MuiMenuItem-root": {
    padding: "8px 12px",
  },
}));

export default useStyles;
